import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "../../lib/api";
import { PageHeader, Badge, Table } from "../../components/admin/AdminUI";
import { CampaignSheet } from "./AdminCampaigns";

export default function AdminApprovals() {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);
  const load = () => api.get("/admin/email/campaigns", { params: { status: "pending_approval" } }).then((r) => setItems(r.data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  return (
    <div data-testid="admin-approvals">
      <PageHeader title="Approval Queue" subtitle="Review content and audience. Creators cannot approve their own campaigns." />
      <Table testid="approvals-table" rows={items} onRow={(r) => setSel(r.id)} empty="No campaigns awaiting approval" cols={[["name", "Campaign"], ["subject", "Subject"], ["status", "Status", (r) => <Badge s={r.status} />],
        ["recipient_count", "Recipients"], ["submitted_by", "Submitted by"], ["submitted_at", "Submitted", (r) => fmtDateTime(r.submitted_at)]]} />
      <CampaignSheet id={sel} onClose={() => setSel(null)} onChanged={load} />
    </div>
  );
}
